import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-replace-material-file';

export const replaceContentMaterialFile = ({
  id,
  file,
  managerId,
}: contentApiTypes.ReplaceMaterialFileParams) => {
  const formData = new FormData();
  formData.append('file', file);
  if (managerId) {
    formData.append('managerId', managerId);
  }

  return axios.post(`/content/materials/${id}/file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }) as Promise<contentApiTypes.ReplaceMaterialFileResponse>;
};

type ReplaceContentMaterialFileOptions = {
  pageId?: string;
  config?: MutationConfig<typeof replaceContentMaterialFile>;
};

export const useReplaceContentMaterialFile = ({
  pageId,
  config = {},
}: ReplaceContentMaterialFileOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: replaceContentMaterialFile,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Замена файла...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Файл заменён');
      if (pageId) {
        queryClient.invalidateQueries(['content-materials', pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
